let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ib8vr")).then(() => parcelRequire('5L5lX'));